import { GQLLocalCartArticle } from '~/graphql/__generated__/interfacesLocal'

export const YOTTLY_TRACKING_EVENT_NAME = 'yottly-tracking'

interface CartInteractionFuncParams {
  onOrderPage?: boolean
  content: {
    productId: string
    amount: number
  }[]
}
interface CartInteractionFunc {
  (params: CartInteractionFuncParams): any
}
export interface YottlyGlobalObject {
  cartInteraction: CartInteractionFunc
}

export interface YottlyEventData {
  id: string
  onOrderPage?: boolean
  articles?: GQLLocalCartArticle[]
}

export enum YottlyEventTypes {
  CartInteraction = 'cartInteraction',
}

export interface YottlyEvent extends Event {
  detail: {
    data: YottlyEventData
    eventType: YottlyEventTypes
  }
}

export interface YottlyCartInteractionEvent extends YottlyEvent {
  detail: {
    data: YottlyEventData
    eventType: YottlyEventTypes.CartInteraction
  }
}

export const createCartInteractionEvent = (
  data: YottlyEventData
): YottlyCartInteractionEvent =>
  new CustomEvent(YOTTLY_TRACKING_EVENT_NAME, {
    bubbles: true,
    detail: { data, eventType: YottlyEventTypes.CartInteraction },
  })
